import { useState, useEffect } from 'react';

const translations = {
  fr: {
    // Nav
    accueil: 'Accueil',
    la_carte: 'La Carte',
    bons_cadeaux: 'Bons Cadeaux',
    galerie: 'Galerie',
    a_propos: 'A propos',
    contact: 'Contact',
    reserver: 'Reserver',
    traiteur: 'Traiteur',
    restaurant: 'Restaurant',
    // Hero
    hero_line1: 'Une cuisine authentique',
    hero_line2: 'du terroir catalan',
    hero_desc: 'Depuis 2009, Le Mas vous accueille dans un cadre chaleureux pour une experience gastronomique unique melant traditions et creativite.',
    voir_carte: 'Voir la carte',
    reserver_table: 'Reserver une table',
    avis_google: 'avis Google',
    // Menu page
    menu_sub: 'Restaurant Le Mas',
    menu_title: 'La Carte',
    notre: 'Notre',
    carte: 'Carte',
    suggestion_du: 'Suggestion du',
    menu_du_jour: 'Menu du Jour',
    entrees: 'Entrees',
    plats: 'Plats',
    desserts: 'Desserts',
    formules: 'Formules',
    midi: 'Midi',
    nos_formules: 'Nos Formules du Midi',
    // Categories
    tapas: 'Tapas',
    entree: 'Entrees',
    plat_viande: 'Plats Viande',
    plat_poisson: 'Plats Poisson',
    garniture: 'Garnitures',
    dessert: 'Desserts',
    aperitif: 'Aperitifs',
    soft: 'Softs & Jus',
    cafe: 'Cafes & Thes',
    biere: 'Bieres',
    champagne: 'Champagnes',
    spiritueux: 'Spiritueux & Digestifs',
    vin_blanc: 'Vins Blancs',
    vin_rose: 'Vins Roses',
    vin_rouge: 'Vins Rouges',
    // Footer & Contact
    horaires: 'Horaires',
    navigation: 'Navigation',
    lundi: 'Lundi', mardi: 'Mardi', mercredi: 'Mercredi', jeudi: 'Jeudi',
    vendredi: 'Vendredi', samedi: 'Samedi', dimanche: 'Dimanche',
    ferme: 'Ferme',
    // Contact page
    venez: 'Venez nous rendre visite',
    adresse: 'Adresse',
    // Misc
    carte_bientot: 'La carte sera bientot disponible.',
    prestations: 'Prestations',
    plateaux: 'Plateaux',
    choisir_langue: 'Choisir la langue',
    // Bons cadeaux
    bons_title: 'Bons Cadeaux',
    bons_sub: 'Offrez une experience',
    // A propos
    notre_histoire: 'Notre histoire',
    a_propos_sub: 'Depuis 2009',
    // Gallery
    galerie_title: 'Galerie',
    galerie_sub: 'Nos moments',
    reservez_titre: 'Reservez votre table',
    reservez_desc: 'Pour une soiree romantique, un repas en famille ou entre amis, nous vous accueillons avec plaisir.',
    reserver_en_ligne: 'Reserver en ligne',
    voir_galerie: 'Voir toute la galerie',
    histoire_sub: 'Notre Histoire',
    passion1: 'Une passion',
    passion2: 'transmise',
    histoire_p1: 'Depuis 2009, notre famille perpetue l\'art de la cuisine mediterraneenne. Chaque plat raconte une histoire, celle de nos producteurs locaux, de nos recettes traditionnelles revisitees avec creativite.',
    histoire_p2: 'Notre chef selectionne chaque jour les meilleurs produits du marche pour vous offrir une experience culinaire authentique et raffinee.',
    en_savoir_plus: 'En savoir plus',
    art_table: 'L\'art de la table',
    ans_experience: 'ans d\'experience',
  },
  en: {
    accueil: 'Home',
    la_carte: 'Menu',
    bons_cadeaux: 'Gift Cards',
    galerie: 'Gallery',
    a_propos: 'About',
    contact: 'Contact',
    reserver: 'Book',
    traiteur: 'Catering',
    restaurant: 'Restaurant',
    hero_line1: 'Authentic cuisine',
    hero_line2: 'from the Catalan region',
    hero_desc: 'Since 2009, Le Mas welcomes you in a warm setting for a unique gastronomic experience blending traditions and creativity.',
    voir_carte: 'View menu',
    reserver_table: 'Book a table',
    avis_google: 'Google reviews',
    menu_sub: 'Restaurant Le Mas',
    menu_title: 'The Menu',
    notre: 'Our',
    carte: 'Menu',
    suggestion_du: 'Suggestion of the',
    menu_du_jour: 'Daily Menu',
    entrees: 'Starters',
    plats: 'Main Courses',
    desserts: 'Desserts',
    formules: 'Set Menus',
    midi: 'Lunch',
    nos_formules: 'Our Lunch Set Menus',
    tapas: 'Tapas',
    entree: 'Starters',
    plat_viande: 'Meat Dishes',
    plat_poisson: 'Fish Dishes',
    garniture: 'Side Dishes',
    dessert: 'Desserts',
    aperitif: 'Aperitifs',
    soft: 'Soft Drinks & Juices',
    cafe: 'Coffee & Tea',
    biere: 'Beers',
    champagne: 'Champagnes',
    spiritueux: 'Spirits & Digestifs',
    vin_blanc: 'White Wines',
    vin_rose: 'Rose Wines',
    vin_rouge: 'Red Wines',
    horaires: 'Opening Hours',
    navigation: 'Navigation',
    lundi: 'Monday', mardi: 'Tuesday', mercredi: 'Wednesday', jeudi: 'Thursday',
    vendredi: 'Friday', samedi: 'Saturday', dimanche: 'Sunday',
    ferme: 'Closed',
    venez: 'Come visit us',
    adresse: 'Address',
    carte_bientot: 'The menu will be available soon.',
    prestations: 'Services',
    plateaux: 'Platters',
    choisir_langue: 'Choose language',
    bons_title: 'Gift Cards',
    bons_sub: 'Give an experience',
    notre_histoire: 'Our story',
    a_propos_sub: 'Since 2009',
    galerie_title: 'Gallery',
    galerie_sub: 'Our moments',
    reservez_titre: 'Book your table',
    reservez_desc: 'For a romantic evening, a family meal or with friends, we welcome you with pleasure.',
    reserver_en_ligne: 'Book online',
    voir_galerie: 'View full gallery',
    histoire_sub: 'Our Story',
    passion1: 'A shared',
    passion2: 'passion',
    histoire_p1: 'Since 2009, our family has been perpetuating the art of Mediterranean cuisine. Each dish tells a story, that of our local producers and our traditional recipes revisited with creativity.',
    histoire_p2: 'Our chef selects the best market products every day to offer you an authentic and refined culinary experience.',
    en_savoir_plus: 'Learn more',
    art_table: 'The art of dining',
    ans_experience: 'years of experience',
  },
  es: {
    accueil: 'Inicio',
    la_carte: 'La Carta',
    bons_cadeaux: 'Tarjetas Regalo',
    galerie: 'Galeria',
    a_propos: 'Nosotros',
    contact: 'Contacto',
    reserver: 'Reservar',
    traiteur: 'Catering',
    restaurant: 'Restaurante',
    hero_line1: 'Cocina autentica',
    hero_line2: 'de la region catalana',
    hero_desc: 'Desde 2009, Le Mas le acoge en un entorno calido para una experiencia gastronomica unica que mezcla tradiciones y creatividad.',
    voir_carte: 'Ver la carta',
    reserver_table: 'Reservar mesa',
    avis_google: 'opiniones Google',
    menu_sub: 'Restaurante Le Mas',
    menu_title: 'La Carta',
    notre: 'Nuestra',
    carte: 'Carta',
    suggestion_du: 'Sugerencia del',
    menu_du_jour: 'Menu del Dia',
    entrees: 'Entrantes',
    plats: 'Platos',
    desserts: 'Postres',
    formules: 'Menus',
    midi: 'Mediodia',
    nos_formules: 'Nuestros Menus del Mediodia',
    tapas: 'Tapas',
    entree: 'Entrantes',
    plat_viande: 'Carnes',
    plat_poisson: 'Pescados',
    garniture: 'Guarniciones',
    dessert: 'Postres',
    aperitif: 'Aperitivos',
    soft: 'Refrescos & Zumos',
    cafe: 'Cafes & Tes',
    biere: 'Cervezas',
    champagne: 'Champanes',
    spiritueux: 'Licores & Digestivos',
    vin_blanc: 'Vinos Blancos',
    vin_rose: 'Vinos Rosados',
    vin_rouge: 'Vinos Tintos',
    horaires: 'Horarios',
    navigation: 'Navegacion',
    lundi: 'Lunes', mardi: 'Martes', mercredi: 'Miercoles', jeudi: 'Jueves',
    vendredi: 'Viernes', samedi: 'Sabado', dimanche: 'Domingo',
    ferme: 'Cerrado',
    venez: 'Venga a visitarnos',
    adresse: 'Direccion',
    carte_bientot: 'La carta estara disponible pronto.',
    prestations: 'Servicios',
    plateaux: 'Bandejas',
    choisir_langue: 'Elegir idioma',
    bons_title: 'Tarjetas Regalo',
    bons_sub: 'Regale una experiencia',
    notre_histoire: 'Nuestra historia',
    a_propos_sub: 'Desde 2009',
    galerie_title: 'Galeria',
    galerie_sub: 'Nuestros momentos',
    reservez_titre: 'Reserve su mesa',
    reservez_desc: 'Para una velada romantica, una comida en familia o con amigos, le acogemos con gusto.',
    reserver_en_ligne: 'Reservar en linea',
    voir_galerie: 'Ver toda la galeria',
    histoire_sub: 'Nuestra Historia',
    passion1: 'Una pasion',
    passion2: 'transmitida',
    histoire_p1: 'Desde 2009, nuestra familia perpetua el arte de la cocina mediterranea. Cada plato cuenta una historia, la de nuestros productores locales y nuestras recetas tradicionales revisitadas con creatividad.',
    histoire_p2: 'Nuestro chef selecciona cada dia los mejores productos del mercado para ofrecerle una experiencia culinaria autentica y refinada.',
    en_savoir_plus: 'Saber mas',
    art_table: 'El arte de la mesa',
    ans_experience: 'anos de experiencia',
  },
  ca: {
    accueil: 'Inici',
    la_carte: 'La Carta',
    bons_cadeaux: 'Targetes Regal',
    galerie: 'Galeria',
    a_propos: 'Sobre nosaltres',
    contact: 'Contacte',
    reserver: 'Reservar',
    traiteur: 'Catering',
    restaurant: 'Restaurant',
    hero_line1: 'Cuina autentica',
    hero_line2: 'del terreny catala',
    hero_desc: 'Des de 2009, Le Mas us acull en un entorn calid per a una experiencia gastronomica unica que barreja tradicions i creativitat.',
    voir_carte: 'Veure la carta',
    reserver_table: 'Reservar taula',
    avis_google: 'opinions Google',
    menu_sub: 'Restaurant Le Mas',
    menu_title: 'La Carta',
    notre: 'La nostra',
    carte: 'Carta',
    suggestion_du: 'Suggeriment del',
    menu_du_jour: 'Menu del Dia',
    entrees: 'Entrants',
    plats: 'Plats',
    desserts: 'Postres',
    formules: 'Menus',
    midi: 'Migdia',
    nos_formules: 'Els nostres Menus del Migdia',
    tapas: 'Tapes',
    entree: 'Entrants',
    plat_viande: 'Carns',
    plat_poisson: 'Peixos',
    garniture: 'Guarnicions',
    dessert: 'Postres',
    aperitif: 'Aperitius',
    soft: 'Refrescs & Sucs',
    cafe: 'Cafes & Tes',
    biere: 'Cerveses',
    champagne: 'Caves',
    spiritueux: 'Licors & Digestius',
    vin_blanc: 'Vins Blancs',
    vin_rose: 'Vins Rosats',
    vin_rouge: 'Vins Negres',
    horaires: 'Horaris',
    navigation: 'Navegacio',
    lundi: 'Dilluns', mardi: 'Dimarts', mercredi: 'Dimecres', jeudi: 'Dijous',
    vendredi: 'Divendres', samedi: 'Dissabte', dimanche: 'Diumenge',
    ferme: 'Tancat',
    venez: 'Veniu a visitar-nos',
    adresse: 'Adreca',
    carte_bientot: 'La carta estara disponible aviat.',
    prestations: 'Serveis',
    plateaux: 'Safates',
    choisir_langue: 'Triar idioma',
    bons_title: 'Targetes Regal',
    bons_sub: 'Regaleu una experiencia',
    notre_histoire: 'La nostra historia',
    a_propos_sub: 'Des de 2009',
    galerie_title: 'Galeria',
    galerie_sub: 'Els nostres moments',
    reservez_titre: 'Reserveu la vostra taula',
    reservez_desc: 'Per a un sopar romantic, un apat en familia o amb amics, us acollim amb plaer.',
    reserver_en_ligne: 'Reservar en linia',
    voir_galerie: 'Veure tota la galeria',
    histoire_sub: 'La nostra Historia',
    passion1: 'Una passio',
    passion2: 'transmesa',
    histoire_p1: 'Des de 2009, la nostra familia perpetua l\'art de la cuina mediterrania. Cada plat explica una historia, la dels nostres productors locals i les nostres receptes tradicionals revisitades amb creativitat.',
    histoire_p2: 'El nostre xef selecciona cada dia els millors productes del mercat per oferir-vos una experiencia culinaria autentica i refinada.',
    en_savoir_plus: 'Saber-ne mes',
    art_table: 'L\'art de la taula',
    ans_experience: 'anys d\'experiencia',
  },
};

const FLAGS = {
  fr: { flag: 'https://flagcdn.com/24x18/fr.png', label: 'Francais' },
  en: { flag: 'https://flagcdn.com/24x18/gb.png', label: 'English' },
  es: { flag: 'https://flagcdn.com/24x18/es.png', label: 'Espanol' },
  ca: { flag: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Flag_of_Catalonia.svg/40px-Flag_of_Catalonia.svg.png', label: 'Catala' },
};

const LANGS = ['fr', 'en', 'es', 'ca'];

export function useLang() {
  const [, rerender] = useState(0);
  const stored = typeof window !== 'undefined' ? localStorage.getItem('lm_lang') : null;
  const lang = stored && LANGS.includes(stored) ? stored : 'fr';

  useEffect(() => {
    const handler = () => rerender(n => n + 1);
    window.addEventListener('lm_lang_change', handler);
    return () => window.removeEventListener('lm_lang_change', handler);
  }, []);

  const setLang = (l) => {
    localStorage.setItem('lm_lang', l);
    window.dispatchEvent(new Event('lm_lang_change'));
  };

  const t = (key) => translations[lang]?.[key] || translations.fr[key] || key;

  return { lang, setLang, t, FLAGS, LANGS };
}

export default translations;
